// extracted by mini-css-extract-plugin
export var createdDate = "_l7-1";
export var divider = "_l7-2";
export var headerDivider = "_l7-3";
export var messagesCard = "_l7-0";
export var messagesContainer = "_l7-6";
export var messagesContainerWrapper = "_l7-4";
export var showLeftPanelButton = "_l7-8";
export var topButtons = "_l7-7";
export var withPadding = "_l7-5";